__turbopack_context__.v({
  "className": "fontdisplay_a543767e-module__Zg6DfG__className",
  "variable": "fontdisplay_a543767e-module__Zg6DfG__variable",
});
